export const fontLocale = {
    "vi": {
        url: 'https://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsWzLhneoCrCEswgqSP.woff2',
        name: 'Lexend'
    }
}